<div class="h-full flex flex-col table-container-general">
  <div class="table-container">
    <div class="scroll-table pt-4 pb-2 overflow-y-auto">
      @if (dataSource.data[0]) {
        <table mat-table [dataSource]="dataSource" class="w-full">
          <ng-container [matColumnDef]="column" *ngFor="let column of columns">
            <th
              class="min-w-37.5 text-center text-general font-bold!"
              mat-header-cell
              *matHeaderCellDef
            >
              {{ displayColumns[columns.indexOf(column)][0] }}
            </th>

            @if (columns.indexOf(column) == 0 && hasButton) {
              <div>
                <td mat-cell *matCellDef="let element">
                  @if (displayColumns[columns.indexOf(column)][1] == '') {
                    <mat-radio-button
                      class="flex items-center pl-4"
                      [value]="element[column]"
                      (change)="mainButtonPress(element)"
                      [checked]="element[column] === isRadio"
                    >
                    </mat-radio-button>
                  }
                </td>
              </div>
            }
            @if ((hasButton && columns.indexOf(column) != 0) || !hasButton) {
              <div>
                <td mat-cell *matCellDef="let element">
                  @if (displayColumns[columns.indexOf(column)][1] == '') {
                    <ng-container>
                      {{ element[column] }}
                    </ng-container>
                  }
                  @if (displayColumns[columns.indexOf(column)][1] == '$') {
                    <ng-container>
                      {{ element[column] | currency: 'MXN' }}
                    </ng-container>
                  }

                  @if (displayColumns[columns.indexOf(column)][1] == '%') {
                    <ng-container>
                      {{ element[column] / 100 | percent }}
                    </ng-container>
                  }
                </td>
              </div>
            }
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; let even = even; columns: columns"
            [ngClass]="{ rowColor: even }"
          ></tr>
        </table>
      }
    </div>
  </div>
</div>
